











































import { Vue, Component, Prop } from "vue-property-decorator";

import { ICustomStylingClass } from "./types/custom.t";
import type { subGroupType } from "./types/custom.t";
import CustomContainer from "./CustomContainer.vue";
import CustomText from "@/components/Globals/CustomText.vue";
import SwatchSubGroup from '@/components/Globals/molecule.swatchsubgroup.vue';

@Component({ components: { CustomContainer, SwatchSubGroup, CustomText }})
export default class SwatchGroup extends Vue {

  @Prop()
  customsClass?: ICustomStylingClass[];

  @Prop({default: ''})
  activeGroup!: string;

  @Prop({default: ''})
  groupName!: string;

  @Prop()
  customStyle?: ICustomStylingClass[];

    @Prop()
  swatchesToRenderOrdered!: subGroupType[];

  @Prop({default: ''})
  hasTitle!: string;

  @Prop({default: ''})
  hasSubTitle!: string;

  @Prop({default: ''})
  hasTitleProperties!: boolean;

}
